import { PASSWORD_POLICY_MESSAGE } from '@design/forms/form-validation';

export interface ResetPasswordModalContent {
  title: string;
  message: string;
}

const defaultInvalidTokenModal: ResetPasswordModalContent = {
  title: 'Invalid token',
  message: 'The reset password token is no longer valid.<br> You may wish to restart resetting your password.'
};

export function getResetPassword400Modal(errorBody: { status?: string; message?: string } | undefined): ResetPasswordModalContent {
  switch (errorBody?.status) {
    case 'TokenExpired':
      return {
        title: 'Expired Link',
        message: 'The reset password link has expired.<br> You may wish to restart resetting your password.'
      };
    case 'TokenSpent':
      return {
        title: 'Link already used',
        message: 'The reset password link has already been used.<br> You may wish to restart resetting your password.'
      };
    case 'PasswordNotValid':
      return {
        title: 'Password not valid',
        message: errorBody?.message ?? PASSWORD_POLICY_MESSAGE
      };
    default:
      return defaultInvalidTokenModal;
  }
}
